import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const RollingResistanceCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-rolling-resistance-calculator" />;

export default RollingResistanceCalculatorGuidePage;
